var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _g3, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 149,
    viewBox: "0 0 171 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.4651 148.535C137.353 148.535 170.5 115.388 170.5 74.4998C170.5 33.6114 137.353 0.464844 96.4651 0.464844C55.5767 0.464844 22.4302 33.6114 22.4302 74.4998C22.4302 115.388 55.5767 148.535 96.4651 148.535Z",
    fill: "#FCFCFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2765_7883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2118 63.7056L149.271 63.7056C150.313 63.7056 151.312 64.1194 152.048 64.8561C152.785 65.5927 153.199 66.5919 153.199 67.6337V87.2742C153.199 88.316 152.785 89.3152 152.048 90.0518C151.312 90.7885 150.313 91.2024 149.271 91.2024L43.2118 91.2024C42.17 91.2024 41.1709 90.7885 40.4342 90.0518C39.6975 89.3152 39.2837 88.316 39.2837 87.2742V67.6337C39.2837 66.5919 39.6975 65.5927 40.4342 64.8561C41.1709 64.1194 42.17 63.7056 43.2118 63.7056V63.7056Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.345 69.9922H80.9189C79.6172 69.9922 78.562 71.0474 78.562 72.3491C78.562 73.6507 79.6172 74.7059 80.9189 74.7059H101.345C102.647 74.7059 103.702 73.6507 103.702 72.3491C103.702 71.0474 102.647 69.9922 101.345 69.9922Z",
    fill: "#D0D5DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.486 80.2046H80.9189C79.6172 80.2046 78.562 81.2598 78.562 82.5615C78.562 83.8631 79.6172 84.9183 80.9189 84.9183H115.486C116.788 84.9183 117.843 83.8631 117.843 82.5615C117.843 81.2598 116.788 80.2046 115.486 80.2046Z",
    fill: "#EAECF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2442 84.9205C67.3661 84.9205 70.7076 81.579 70.7076 77.4571C70.7076 73.3351 67.3661 69.9937 63.2442 69.9937C59.1222 69.9937 55.7808 73.3351 55.7808 77.4571C55.7808 81.579 59.1222 84.9205 63.2442 84.9205Z",
    fill: "#98A2B3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5015 81.2254V73.8921H63.2962C63.8377 73.8921 64.2861 73.978 64.6414 74.1499C64.9966 74.3194 65.2624 74.5498 65.4388 74.841C65.6152 75.1298 65.7034 75.4557 65.7034 75.8185C65.7034 76.1241 65.645 76.3819 65.5282 76.592C65.4115 76.7996 65.255 76.9667 65.0587 77.0933C64.8649 77.2174 64.6513 77.3081 64.4178 77.3654V77.437C64.6712 77.4489 64.9184 77.5277 65.1593 77.6733C65.4028 77.8166 65.604 78.0207 65.763 78.2856C65.922 78.5506 66.0015 78.8729 66.0015 79.2524C66.0015 79.6272 65.9095 79.9638 65.7257 80.2622C65.5444 80.5582 65.2637 80.7933 64.8836 80.9676C64.5035 81.1395 64.0178 81.2254 63.4266 81.2254H60.5015ZM61.6529 80.2765H63.3148C63.8663 80.2765 64.2613 80.1739 64.4998 79.9686C64.7383 79.7633 64.8575 79.5067 64.8575 79.1987C64.8575 78.9672 64.7966 78.7547 64.6749 78.5614C64.5532 78.368 64.3793 78.214 64.1532 78.0994C63.9296 77.9849 63.6638 77.9276 63.3558 77.9276H61.6529V80.2765ZM61.6529 77.0646H63.1956C63.4539 77.0646 63.6862 77.0169 63.8924 76.9214C64.1011 76.8259 64.2663 76.6922 64.388 76.5203C64.5122 76.3461 64.5743 76.1408 64.5743 75.9045C64.5743 75.6013 64.4638 75.3471 64.2427 75.1418C64.0216 74.9365 63.6825 74.8338 63.2254 74.8338H61.6529V77.0646Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2765_7883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.42958 97.4893H115.489C116.53 97.4893 117.53 97.9031 118.266 98.6398C119.003 99.3764 119.417 100.376 119.417 101.417L119.417 121.058C119.417 122.1 119.003 123.099 118.266 123.836C117.53 124.572 116.53 124.986 115.489 124.986H9.42958C8.38778 124.986 7.38865 124.572 6.65198 123.836C5.91532 123.099 5.50146 122.1 5.50146 121.058L5.50146 101.417C5.50146 100.376 5.91532 99.3764 6.65198 98.6398C7.38865 97.9031 8.38778 97.4893 9.42958 97.4893V97.4893Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5648 103.776H47.1386C45.8369 103.776 44.7817 104.831 44.7817 106.133C44.7817 107.434 45.8369 108.49 47.1386 108.49H67.5648C68.8665 108.49 69.9217 107.434 69.9217 106.133C69.9217 104.831 68.8665 103.776 67.5648 103.776Z",
    fill: "#D0D5DD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.706 113.988H47.1386C45.8369 113.988 44.7817 115.043 44.7817 116.345C44.7817 117.647 45.8369 118.702 47.1386 118.702H81.706C83.0077 118.702 84.0629 117.647 84.0629 116.345C84.0629 115.043 83.0077 113.988 81.706 113.988Z",
    fill: "#EAECF0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 118.707C23.372 118.707 26.7134 115.365 26.7134 111.243C26.7134 107.121 23.372 103.78 19.25 103.78C15.1281 103.78 11.7866 107.121 11.7866 111.243C11.7866 115.365 15.1281 118.707 19.25 118.707Z",
    fill: "#98A2B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.43 109.754C20.395 109.443 20.2506 109.203 19.9969 109.032C19.7432 108.859 19.4238 108.773 19.0389 108.773C18.7633 108.773 18.5249 108.817 18.3237 108.904C18.1224 108.989 17.966 109.108 17.8545 109.259C17.7451 109.407 17.6905 109.577 17.6905 109.767C17.6905 109.927 17.7276 110.065 17.802 110.18C17.8786 110.296 17.9781 110.394 18.1006 110.472C18.2252 110.549 18.3587 110.614 18.5008 110.666C18.643 110.716 18.7797 110.758 18.9109 110.791L19.5671 110.961C19.7814 111.014 20.0013 111.085 20.2265 111.175C20.4518 111.264 20.6607 111.382 20.8532 111.529C21.0457 111.675 21.201 111.857 21.3191 112.073C21.4394 112.29 21.4995 112.549 21.4995 112.851C21.4995 113.232 21.4011 113.57 21.2042 113.865C21.0096 114.16 20.7263 114.393 20.3545 114.564C19.9849 114.734 19.5376 114.82 19.0126 114.82C18.5096 114.82 18.0743 114.74 17.7069 114.58C17.3394 114.42 17.0518 114.194 16.844 113.901C16.6362 113.606 16.5214 113.256 16.4995 112.851H17.5166C17.5363 113.094 17.615 113.296 17.7528 113.458C17.8928 113.618 18.071 113.737 18.2876 113.816C18.5063 113.892 18.7458 113.93 19.0061 113.93C19.2926 113.93 19.5474 113.886 19.7705 113.796C19.9958 113.704 20.173 113.577 20.302 113.415C20.4311 113.251 20.4956 113.06 20.4956 112.841C20.4956 112.642 20.4387 112.479 20.325 112.352C20.2134 112.225 20.0614 112.121 19.8689 112.037C19.6786 111.954 19.4632 111.881 19.2226 111.818L18.4286 111.601C17.8906 111.454 17.4641 111.239 17.1491 110.955C16.8363 110.67 16.68 110.294 16.68 109.826C16.68 109.439 16.7849 109.101 16.9949 108.812C17.2049 108.524 17.4892 108.299 17.8479 108.14C18.2066 107.978 18.6113 107.897 19.0618 107.897C19.5168 107.897 19.9181 107.977 20.2659 108.136C20.6159 108.296 20.8915 108.516 21.0927 108.796C21.2939 109.074 21.3989 109.393 21.4076 109.754H20.43Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2765_7883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.487 29.9219H9.42811C7.25868 29.9219 5.5 31.6806 5.5 33.85L5.5 53.4905C5.5 55.66 7.25868 57.4187 9.42811 57.4187H115.487C117.657 57.4187 119.415 55.66 119.415 53.4905L119.415 33.85C119.415 31.6806 117.657 29.9219 115.487 29.9219Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.993 36.2085H45.5668C44.2652 36.2085 43.21 37.2637 43.21 38.5654C43.21 39.867 44.2652 40.9222 45.5668 40.9222H65.993C67.2947 40.9222 68.3499 39.867 68.3499 38.5654C68.3499 37.2637 67.2947 36.2085 65.993 36.2085Z",
    fill: "#D0D5DD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1342 46.4209H45.5668C44.2652 46.4209 43.21 47.4761 43.21 48.7778C43.21 50.0794 44.2652 51.1346 45.5668 51.1346H80.1342C81.4359 51.1346 82.4911 50.0794 82.4911 48.7778C82.4911 47.4761 81.4359 46.4209 80.1342 46.4209Z",
    fill: "#EAECF0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4624 51.1358C33.5844 51.1358 36.9259 47.7943 36.9259 43.6724C36.9259 39.5505 33.5844 36.209 29.4624 36.209C25.3405 36.209 21.999 39.5505 21.999 43.6724C21.999 47.7943 25.3405 51.1358 29.4624 51.1358Z",
    fill: "#98A2B3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5738 46.8887H26.499L28.9141 39.8887H30.0839L32.499 46.8887H31.4242L29.5269 41.1602H29.4744L27.5738 46.8887ZM27.7541 44.1475H31.2407V45.0361H27.7541V44.1475Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2765_7883",
    x: 37.2837,
    y: 61.7056,
    width: 123.915,
    height: 37.4966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2765_7883"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2765_7883",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2765_7883",
    x: 0.501465,
    y: 95.4893,
    width: 123.915,
    height: 37.4966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2765_7883"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2765_7883",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2765_7883",
    x: 0.5,
    y: 27.9219,
    width: 123.915,
    height: 37.4966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.230539 0 0 0 0 0.370572 0 0 0 0 0.482993 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2765_7883"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2765_7883",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransaction);
export default __webpack_public_path__ + "static/media/noTransaction.ce2751fb8d6b3aba3c19051264127133.svg";
export { ForwardRef as ReactComponent };